// extracted by mini-css-extract-plugin
export default {"button_burger__svg":"ButtonBurger_button_burger__svg__l9Ga7"};